export const LEARN_BUNDLES = {
  es: () => import('./es/bundle.json'),
  fr: () => import('./fr/bundle.json'),
  pt: () => import('./pt/bundle.json'),
  de: () => import('./de/bundle.json'),
  pl: () => import('./pl/bundle.json'),
  zh: () => import('./zh/bundle.json'),
  ar: () => import('./ar/bundle.json'),
};
